<div *ngIf="item && item.cells" class="container flex flex-row justify-between">

    <div class="flex flex-row justify-start items-start full-grow-no-shrink-no-basis" style="width: 0">
        <div class="text-ellipsis full-grow-no-shrink-no-basis"
             title="{{item.cells[fieldDefinition.key] ? (item.cells[this.fieldDefinition.key].value?.toolTip ? item.cells[this.fieldDefinition.key].value?.toolTip : item.cells[fieldDefinition.key].displayText) : ''}}"
             [innerHTML]="item.cells[fieldDefinition.key] ? item.cells[fieldDefinition.key].displayText : '' | sanitizeHtml">
        </div>
    </div>

    <div class="flex flex-row justify-between items-center">
        <button
                (click)="onClicked('Refresh')"
                *ngIf="item.cells[this.fieldDefinition.key]?.metaData?.EnableResetIcon"
                class="icon-dropdown-button" matTooltip="Refresh" mat-icon-button>
            <mat-icon>cached</mat-icon>
        </button>

        <button
                (click)="onClicked('Edit')"
                *ngIf="!item?.cells[this.fieldDefinition.key].metaData?.IsReadOnly"
                class="icon-dropdown-button" matTooltip="Edit" mat-icon-button>
            <mat-icon>create</mat-icon>
        </button>
    </div>

    <Button *ngIf="item.cells[footNoteKey]?.value" class="note-cell-arrow" (click)="openFootNote()">
        <div class="arrow-left"></div>
    </Button>
</div>
